import {BloodGroup, Gender, MaritalStatus, Primary} from "../../../../../domains/models/employee";
import {IData, IPrimaryDetailFormModel, IReportingManager} from "../types/primary-detail.types";
import server from "../../../../../server";
import dayjs from "dayjs";
import {convertToApiFormat, convertToDisplayFormat} from '../../../../../utility/date.utils'

export function viewMapper(data: IData): IPrimaryDetailFormModel {
    const {primary} = data;

    return {
        userId: primary.userId,
        firstName: primary.name.firstName,
        middleName: primary.name.middleName,
        lastName: primary.name.lastName,
        maritalStatus: primary.maritalStatus,
        gender: primary.gender,
        // dateOfBirth: primary.dateOfBirth ? dayjs(primary.dateOfBirth, "YYYY-MM-DD") : null,
        dateOfBirth: convertToDisplayFormat(primary.dateOfBirth),
        age: dobToAgeInYears(primary.dateOfBirth),
        // joiningDate: primary.joiningDate ? dayjs(primary.joiningDate, "YYYY-MM-DD") : null,
        joiningDate: convertToDisplayFormat(primary.joiningDate),
        officialEmailId: primary.officialEmailId,
        bloodGroup: primary.bloodGroup,
        // aadharNumber: primary.aadharCard?.number,
        // aadharDocumentId: primary.aadharCard?.id,
        // panNumber: primary.panCard?.number,
        // panDocumentId: primary.panCard?.id,
        reportingId: primary.reportingId,
        employeeCode: primary.employeeCode,
    };
}

export function modelMapper(data: IPrimaryDetailFormModel): Primary {
    return {
        userId: data.userId,
        name: {
            firstName: data.firstName,
            middleName: data.middleName,
            lastName: data.lastName,
        },
        gender: data.gender as Gender,
        // aadharCard: {
        //     id: data.aadharDocumentId,
        //     number: data.aadharNumber
        // },
        // panCard: {
        //     id: data.panDocumentId,
        //     number: data.panNumber
        // },
        employeeCode: data.employeeCode,
        officialEmailId: data.officialEmailId,
        joiningDate: data.joiningDate!.utc(true).toDate(),
        maritalStatus: data.maritalStatus as MaritalStatus,
        reportingId: data.reportingId,
        bloodGroup: data.bloodGroup as BloodGroup,
        dateOfBirth: convertToApiFormat(data.dateOfBirth)
    };
}


export async function fetchData(employeeId: string): Promise<IData> {
    const primary: Primary = await server.employee.primary.get(employeeId);
    return {
        primary
    };
}

function dobToAgeInYears(dateOfBirth?: Date): number | undefined {
    let age;
    if (dateOfBirth) {
        const birthDate = dayjs(dateOfBirth);
        const today = dayjs();
        age = today.year() - birthDate.year();
        if (
            today.month() < birthDate.month() ||
            (today.month() === birthDate.month() && today.date() < birthDate.date())
        ) {
            age--;
        }
    }
    return age;
}

export const initialState = {
    primary: {
        name: {
            firstName: '',
            middleName: '',
            lastName: ''
        },
        maritalStatus: '' as MaritalStatus,
        gender: '' as Gender,
        dateOfBirth: '',
        bloodGroup: '' as BloodGroup,
        aadharCard: {
            id: '',
            number: ''
        },
        panCard: {
            id: '',
            number: ''
        },
        joiningDate: '',
        officialEmailId: '',
        reportingId: '',
        employeeCode: '',
    }
}

export const initialFormData = {
    firstName: '',
    middleName: '',
    lastName: '',
    maritalStatus: '',
    gender: '',
    dateOfBirth: null,
    age: undefined,
    bloodGroup: '',
    aadharNumber: '',
    aadharDocumentId: '',
    panNumber: '',
    panDocumentId: '',
    joiningDate: null,
    officialEmailId: '',
    reportingId: '',
    employeeCode: '',
}
